import { Cluster, ParticipantFace, Stack, Typography } from '@src/components';
import { ThemeArtwork } from '@src/theme/Artwork';
import './GifteePair.css';

export interface GifteePairPerson {
  username: string;
  picture?: string | null;
}

export interface GifteePairProps {
  santa: GifteePairPerson;
  giftee: GifteePairPerson;
  santaLabel: string;
  gifteeLabel: string;
  testId?: string;
}

/** Who gives to whom. Shown to the organizer on request, never by default. */
export function GifteePair({ santa, giftee, santaLabel, gifteeLabel, testId }: GifteePairProps) {
  return (
    <Cluster gap={5} align="center" justify="center" className="giftee-pair" testId={testId}>
      <Stack gap={2} align="center" className="giftee-pair__person">
        <Typography as="p" role="meta/caps">
          {santaLabel}
        </Typography>
        <ParticipantFace picture={santa.picture} size="card" />
        <Typography as="p" role="body/strong">
          {santa.username}
        </Typography>
      </Stack>
      <ThemeArtwork role="gift" className="giftee-pair__gift" />
      <Stack gap={2} align="center" className="giftee-pair__person">
        <Typography as="p" role="meta/caps">
          {gifteeLabel}
        </Typography>
        <ParticipantFace picture={giftee.picture} size="card" />
        <Typography as="p" role="body/strong">
          {giftee.username}
        </Typography>
      </Stack>
    </Cluster>
  );
}
